export const ACCESS_CONTROL = '/permission-management'
export const ACCESS_CONTROL_ROLES = `${ACCESS_CONTROL}/roles`
export const ACCESS_CONTROL_ROLE_DETAIL = `${ACCESS_CONTROL}/roles/:roleId`
export const ACCESS_CONTROL_USERS = `${ACCESS_CONTROL}/users`
